import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "home": "Home",
      "schedule": "Schedule",
      "register": "Register",
      "about": "About",
      "events": "Events",
      "gallery": "Gallery",
      "contact": "Contact",
      
      // Hero
      "tagline": "Race. Play. Build. Create.",
      "registerNow": "Register Now",
      "viewSchedule": "View Schedule",
      
      // Common
      "learnMore": "Learn More",
      "contactUs": "Contact Us",
      "readMore": "Read More",
      
      // Event Zones
      "droneSoccer": "Drone Soccer Arena",
      "droneSimulator": "Drone Simulator Zone",
      "experienceZone": "Experience Zone",
      "roboBattle": "Robo Battle Championship",
      "fpvRace": "FPV Drone Race",
      
      // Schedule
      "eventSchedule": "Event Schedule",
      "poweredBy": "Powered by SKY 7",
      "day": "Day",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "eventTime": "Event Time",
      "allTimeActivities": "All-Time Activities",
      "scheduledHighlight": "Scheduled Highlight",
      "scheduledHighlights": "Scheduled Highlights",
      
      // Registration
      "visitorRegistration": "Visitor Registration",
      "name": "Name",
      "email": "Email",
      "phone": "Phone Number",
      "visitDate": "Visit Date",
      "selectDate": "Select Date",
      "entryFee": "Entry Fee",
      "omr": "OMR",
      "proceedToPayment": "Proceed to Payment",

      // Brand
      "brandName": "Oman Drone"
    }
  },
  ar: {
    translation: {
      // Navigation
      "home": "الرئيسية",
      "schedule": "الجدول الزمني",
      "register": "التسجيل",
      "about": "عن الكرنفال",
      "events": "الفعاليات",
      "gallery": "المعرض",
      "contact": "اتصل بنا",
      
      // Hero
      "tagline": "سابق. العب. ابنِ. أبدع.",
      "registerNow": "سجل الآن",
      "viewSchedule": "عرض الجدول الزمني",
      
      // Common
      "learnMore": "اعرف المزيد",
      "contactUs": "اتصل بنا",
      "readMore": "اقرأ المزيد",
      
      // Event Zones
      "droneSoccer": "ساحة كرة القدم بالطائرات",
      "droneSimulator": "منطقة محاكي الطائرات",
      "experienceZone": "منطقة التجربة",
      "roboBattle": "بطولة معركة الروبوتات",
      "fpvRace": "سباق الطائرات FPV",
      
      // Schedule
      "eventSchedule": "الجدول الزمني للفعالية",
      "poweredBy": "مدعوم من SKY 7",
      "day": "اليوم",
      "thursday": "الخميس",
      "friday": "الجمعة",
      "saturday": "السبت",
      "eventTime": "وقت الفعالية",
      "allTimeActivities": "الأنشطة طوال الوقت",
      "scheduledHighlight": "أبرز المواعيد",
      "scheduledHighlights": "أبرز المواعيد",
      
      // Registration
      "visitorRegistration": "تسجيل الزوار",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "phone": "رقم الهاتف",
      "visitDate": "تاريخ الزيارة",
      "selectDate": "اختر التاريخ",
      "entryFee": "رسوم الدخول",
      "omr": "ر.ع",
      "proceedToPayment": "المتابعة للدفع",

      // Brand
      "brandName": "عمان درون"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'ar'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
